import { Navigate, useLocation } from "react-router-dom";
import { detectRegion } from "../config/regions";

// Used by the root ("/") and catch-all ("*") routes instead of a hardcoded
// redirect to /nz. It geo-detects the visitor's region client-side and sends
// them to the matching region, carrying over any path/query they arrived with.
const RegionRedirect = () => {
    const location = useLocation();
    const region = detectRegion();

    // Preserve the original path so e.g. "/about" -> "/nz/about", while a bare
    // "/" maps cleanly to "/nz". Query/hash are kept too.
    const suffix = location.pathname === "/" ? "" : location.pathname;
    const target = `/${region}${suffix}${location.search}${location.hash}`;

    return <Navigate to={target} replace />;
};

export default RegionRedirect;
